import { Injectable, NgZone } from "@angular/core";
import {
  WindowService,
  StorageService,
  StorageKeys,
  HelperService,
  UserService,
  ProductService,
  environment,
  ContentService,
  EventBusService,
  CheckoutService,
  OrderService,
} from "@mypxplat/xplat/core";
import { NgbModal, NgbModalOptions, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { CookieService } from "ngx-cookie-service";
import { Router, NavigationEnd } from "@angular/router";
import { Title } from "@angular/platform-browser";
import { AngularFireAuth } from "@angular/fire/compat/auth";
import { filter, takeUntil, take, first, map } from "rxjs/operators";
import { Base64 } from "js-base64";
import { MessagingService } from "./messaging.service";
import moment from "moment";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { BehaviorSubject, firstValueFrom, forkJoin, Subject, fromEvent } from "rxjs";
import { WebCommunityService } from "./community.service";
import { MyFenderWelcomeComponent } from "../../../../features/src/lib/ui/components/modals/my-fender-welcome/my-fender-welcome.component";
import { FeatureUpdatesComponent } from "../../../../features/src/lib/ui/components/modals/feature-updates/feature-updates.component";
import { GenericAlertComponent } from "../../../../features/src/lib/ui/components/modals/generic-alert/generic-alert.component";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import { BetaService } from "./beta.service";
import { fetchUserAttributes } from "aws-amplify/auth";
import { CognitoAccessToken, CognitoIdToken, CognitoRefreshToken, CognitoUser, CognitoUserPool, CognitoUserSession } from "amazon-cognito-identity-js";
import { VerifyEmailComponent } from "../../../../features/src/lib/ui/components/modals/verify-email/verify-email.component";
import { WebErrorHandler } from "./error-handler.service";
import { FirebaseService } from "./firebase.service";
import { AvoService } from "./avo.service";
import { Hub } from "aws-amplify/utils";
import { Amplify } from "aws-amplify";
import { TranslateService } from "@ngx-translate/core";
@Injectable()
export class AppService {
  showLangSwitcher$: Subject<any> = new Subject();
  systemThemeChange$: BehaviorSubject<any> = new BehaviorSubject(window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light");
  sphereAppContentScrolled$: Subject<any> = new Subject();
  heroBgHeight: any = false;
  public headerLogo: string;
  public presonusLogo: string;
  public presonusAdminLogo: string;
  public systemTheme: string;
  public s1pro7Logo: string;
  public s1proPlusLogo: string;

  public perpetualLogo: string;
  public subscriptionLogo: string;

  public s1PlusLogo: string;
  public membershipLogo: string;
  public cognitoUser: CognitoUser;
  public appContainer: any;
  public scrolledContentOffsets: any = {
    exchange: 0,
  };
  public dawBoxArt: string;
  public dawBoxScreenArt: string;
  public fsp8Released: boolean = false;
  public subMonthlyArt: string;
  public subAnnualArt: string;

  constructor(
    private _modalService: NgbModal,
    private win: WindowService,
    private _storage: StorageService,
    private _cookieService: CookieService,
    private router: Router,
    public helperService: HelperService,
    public userService: UserService,
    public productService: ProductService,
    public messagingService: MessagingService,
    public fbAuth: AngularFireAuth,
    public db: AngularFirestore,
    private _title: Title,
    public communityService: WebCommunityService,
    public betaService: BetaService,
    public contentService: ContentService,
    public eventBusService: EventBusService,
    public errorService: WebErrorHandler,
    public fbService: FirebaseService,
    public checkoutService: CheckoutService,
    public avoService: AvoService,
    public orderService: OrderService,
    public translate: TranslateService
  ) {
    this.systemTheme = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
    this.fsp8Released = true;
    this.userService.tokenExpired$.subscribe((result) => {
      if (result) {
        if (
          this.router.url.indexOf("/signup") == -1 &&
          this.router.url != "/studioonedemo" &&
          this.router.url.indexOf("/join") == -1 &&
          this.router.url.indexOf("/createaccount") == -1 &&
          this.router.url.indexOf("/register") == -1
        ) {
          this.router.navigate(["/logout"]);
        }
      }
    });

    this._modalService.activeInstances.subscribe((modals: Array<NgbModalRef>) => {
      modals.forEach((modalRef, index) => {
        // Access the native element of the modal
        const modalElement = (modalRef as any)._windowCmptRef.location.nativeElement;
        // Example: Add a specific class to all but the last modal
        if (index < modals.length - 1) {
          modalElement.classList.add("blurme");
        } else {
          modalElement.classList.remove("blurme");
        }
      });
    });

    this.presonusLogo = this.systemTheme == "dark" ? "./assets/images/pae+white.png" : "./assets/images/pae+black.png";
    this.presonusAdminLogo = this.systemTheme == "dark" ? "./assets/images/paeadmin+white.png" : "./assets/images/paeadmin+black.png";
    this.s1pro7Logo = this.systemTheme == "dark" ? "./assets/images/s17-images/s1pro7-white.png" : "./assets/images/s1pro7-black.png";
    this.s1proPlusLogo = this.systemTheme == "dark" ? "./assets/images/s17-images/s1plus-logo-white.png" : "./assets/images/s17-images/s1plus-logo-black.png";

    this.headerLogo = "./assets/images/fender-logo-red.png";
    this.perpetualLogo = "./assets/images/logos/fsp-black.png";
    this.subscriptionLogo = "./assets/images/logos/fsp+-black.png";

    // Setup Hub listener for Amplify auth events (token refresh)
    this.setupAuthHubListener();

    // Setup ghost nav behavior based on route and scroll
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.checkGhostNavRoute();
      this.setRouteClass();
    });

    // Listen to window scroll events to toggle ghost nav
    fromEvent(window, "scroll", { passive: true }).subscribe(() => {
      const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
      this.handleGhostNavScroll(scrollTop);
    });
  }

  /**
   * Setup Amplify Hub listener to sync tokens to cookies when they refresh
   * This ensures cookies stay in sync with localStorage for cross-domain access
   */
  private setupAuthHubListener(): void {
    Hub.listen("auth", (data) => {
      const { payload } = data;

      if (payload.event === "tokenRefresh") {
        if (!environment.production) {
          console.log("♻️ Token refresh detected - syncing Cognito tokens to cookies");
        }
        // Sync the refreshed tokens from localStorage to cookies
        this.syncCognitoTokensToCookies();
      }
    });
  }

  private _mobileMenuShown: boolean;
  get mobileMenuShown() {
    return this._mobileMenuShown;
  }

  set mobileMenuShown(mobileMenuShown) {
    this._mobileMenuShown = mobileMenuShown;
  }

  get videoContentType() {
    let value: any;
    value = this._storage.getItem(StorageKeys.LEARN_VIDEO_CONTENT_TYPE);
    if (!value) {
      value = {
        fender: true,
        presonus: this.productService.hasRecordingProducts,
      };
    }
    return value;
  }
  set videoContentType(videoContentType) {
    if (videoContentType) this._storage.setItem(StorageKeys.LEARN_VIDEO_CONTENT_TYPE, videoContentType);
  }

  private _app: string;
  get app() {
    return this._app;
  }

  set app(app) {
    this._app = app;
    this._storage.setItem(StorageKeys.APP, app);
  }

  public ghostNavRoutes: { [key: string]: { unset: number } } = {
    home: {
      unset: 100,
    },
  };

  private currentGhostNavRoute: string | null = null;
  private currentRouteClass: string | null = null;

  private _showGhostNav: boolean = false;
  get showGhostNav() {
    return this._showGhostNav;
  }

  set showGhostNav(value: boolean) {
    this._showGhostNav = value;
    let body = document.getElementsByTagName("body")[0];
    if (value) {
      body.classList.add("ghost-nav");
    } else {
      body.classList.remove("ghost-nav");
    }
  }

  public appName: string = "MyPreSonus";

  get isChrome() {
    if (!!(<any>window).chrome && (!!(<any>window).chrome.webstore || !!(<any>window).chrome.runtime)) {
      return true;
    } else {
      return false;
    }
  }

  public storedBodyPosition: number = 0;
  scrollBodyTo(position: number = 0) {
    window.scrollTo({
      top: position,
      behavior: "smooth",
    });
  }

  checkAppVersion() {
    // Check app version by comparing file contents with response header
    // In production, Cloudflare adds X-App-Version header to ALL responses (including version_check.txt)
    this.userService.checkAppVersion().subscribe((response) => {
      const fileVersion = response.body?.trim(); // Version from file contents
      const headerVersion = response.headers.get("X-App-Version"); // Version from response header
      if (!environment.production) {
        console.log("fileVersion", fileVersion);
        console.log("headerVersion", headerVersion);
      }

      if (fileVersion && headerVersion && fileVersion !== headerVersion) {
        // Show user a prompt to refresh the page
        if (!environment.production) console.log("versions do not match!");
        this.eventBusService.emit(this.eventBusService.types.showNewCodeAlert, true);
      } else if (fileVersion === headerVersion) {
        // ✅ Version check passed - app is up to date
        if (!environment.production) console.log("versions match!");
      } else {
        // ℹ️ Version header not present (likely in development
        if (!environment.production) console.log("version header not present!");
      }
    });
  }

  signInFromSavedTokens(accessToken?, idToken?, refreshToken?) {
    if (!accessToken) accessToken = this.helperService.accessToken;
    if (!idToken) idToken = this.helperService.idToken;
    if (!refreshToken) refreshToken = this.helperService.refreshToken;
    if (!this.helperService.accessToken && accessToken) this.helperService.accessToken = accessToken;
    if (!this.helperService.idToken && idToken) this.helperService.idToken = idToken;
    if (!this.helperService.refreshToken && refreshToken) this.helperService.refreshToken = refreshToken;
    if (this.helperService.accessToken && this.helperService.idToken && this.helperService.refreshToken) {
      let isPresonusToken = false;
      let prsAppClients = environment.cognito.appClients;
      // Decode the JWT token to get the aud property
      let idTokenPayload = JSON.parse(atob(idToken.split(".")[1]));
      let idTokenAudience = idTokenPayload.aud;
      for (var i in prsAppClients) {
        if (idTokenAudience == prsAppClients[i]) {
          isPresonusToken = true;
          break;
        }
      }

      let userPoolId = environment.fenderCognito.userPoolId;
      let clientId = environment.fenderCognito.clientId;

      if (isPresonusToken) {
        userPoolId = environment.cognito.userPoolId;
        clientId = environment.cognito.clientId;
      }

      const userPool = new CognitoUserPool({
        UserPoolId: userPoolId,
        ClientId: clientId,
      });
      const cognitoIdToken = new CognitoIdToken({
        IdToken: this.helperService.idToken,
      });
      const cognitoAccessToken = new CognitoAccessToken({
        AccessToken: this.helperService.accessToken,
      });
      const cognitoRefreshToken = new CognitoRefreshToken({
        RefreshToken: this.helperService.refreshToken,
      });
      const username = cognitoAccessToken.payload.username;

      const user = new CognitoUser({
        Username: username,
        Pool: userPool,
      });
      user.setSignInUserSession(
        new CognitoUserSession({
          AccessToken: cognitoAccessToken,
          IdToken: cognitoIdToken,
          RefreshToken: cognitoRefreshToken,
        })
      );

      this.cognitoUser = user;
      return user;
    } else {
      return false;
    }
  }

  setLocalStorageTokens(accessToken, idToken, refreshToken) {
    // decode idToken
    let idTokenPayload = JSON.parse(atob(idToken.split(".")[1]));
    let clientId = idTokenPayload.aud;
    const cognitoPrefix = `CognitoIdentityServiceProvider.${clientId}`;
    localStorage.setItem(`${cognitoPrefix}.LastAuthUser`, idTokenPayload.sub);
    localStorage.setItem(`${cognitoPrefix}.${idTokenPayload.sub}.idToken`, idToken);
    localStorage.setItem(`${cognitoPrefix}.${idTokenPayload.sub}.accessToken`, accessToken);
    localStorage.setItem(`${cognitoPrefix}.${idTokenPayload.sub}.refreshToken`, refreshToken);
    localStorage.setItem(`${cognitoPrefix}.${idTokenPayload.sub}.clockDrift`, "0");
    localStorage.setItem(`${cognitoPrefix}.${idTokenPayload.sub}.signInDetails`, JSON.stringify({ loginId: idTokenPayload.email.toLowerCase(), authFlowType: "USER_PASSWORD_AUTH" }));
  }

  getRefreshTokenFromLocalStorage(clientId?, forceUseFender?) {
    if (!clientId) clientId = forceUseFender ? environment.fenderCognito.clientId : environment.cognito.clientId;
    const lastUserKey = `CognitoIdentityServiceProvider.${clientId}.LastAuthUser`;

    // Try cookies first (primary storage), then localStorage, then sessionStorage (for backward compatibility)
    let lastUser = this._cookieService.get(lastUserKey) || localStorage.getItem(lastUserKey) || sessionStorage.getItem(lastUserKey);

    if (!lastUser) {
      return null;
    }

    const refreshTokenKey = `CognitoIdentityServiceProvider.${clientId}.${lastUser}.refreshToken`;

    // Try cookies first (primary storage), then localStorage, then sessionStorage (for backward compatibility)
    let refreshToken = this._cookieService.get(refreshTokenKey) || localStorage.getItem(refreshTokenKey) || sessionStorage.getItem(refreshTokenKey);
    return refreshToken;
  }

  setTokensFromCookies(clientId?, forceUseFender?) {
    // Auto-detect client ID from stored tokens if not provided
    if (!clientId) {
      clientId = this.detectClientIdFromTokens();
      if (!clientId) {
        // No tokens found, fall back to default
        clientId = forceUseFender ? environment.fenderCognito.clientId : environment.cognito.clientId;
      }
    }

    const lastUserKey = `CognitoIdentityServiceProvider.${clientId}.LastAuthUser`;

    // Try localStorage first (primary storage), then cookies (for cross-domain fallback)
    const lastUser = localStorage.getItem(lastUserKey) || this._cookieService.get(lastUserKey);

    if (lastUser) {
      // Get tokens using Cognito naming pattern, prioritizing localStorage over cookies
      const accessTokenKey = `CognitoIdentityServiceProvider.${clientId}.${lastUser}.accessToken`;
      const idTokenKey = `CognitoIdentityServiceProvider.${clientId}.${lastUser}.idToken`;
      const refreshTokenKey = `CognitoIdentityServiceProvider.${clientId}.${lastUser}.refreshToken`;

      const accessToken = localStorage.getItem(accessTokenKey) || this._cookieService.get(accessTokenKey);
      const idToken = localStorage.getItem(idTokenKey) || this._cookieService.get(idTokenKey);
      const refreshToken = localStorage.getItem(refreshTokenKey) || this._cookieService.get(refreshTokenKey);

      if (accessToken) this.helperService.accessToken = accessToken;
      if (refreshToken) this.helperService.refreshToken = refreshToken;
      if (idToken) {
        this.helperService.idToken = idToken;
        this.helperService.token = this.helperService.idToken; // use the idToken as the token we pass to our api because that is what contains custom user claims (paeid)
        // console.log("setting new tokens with id token " + this.helperService.idToken.substr(this.helperService.idToken.length - 5));
      }
    }
  }

  /**
   * Detect which client ID to use based on tokens stored in localStorage/cookies
   * Returns the client ID from the token's aud claim
   */
  private detectClientIdFromTokens(): string | null {
    // Check PreSonus pool first
    const presonusPrefix = `CognitoIdentityServiceProvider.${environment.cognito.clientId}`;
    const presonusLastAuthUser = localStorage.getItem(`${presonusPrefix}.LastAuthUser`) || this._cookieService.get(`${presonusPrefix}.LastAuthUser`);

    if (presonusLastAuthUser) {
      const presonusIdToken = localStorage.getItem(`${presonusPrefix}.${presonusLastAuthUser}.idToken`) || this._cookieService.get(`${presonusPrefix}.${presonusLastAuthUser}.idToken`);
      if (presonusIdToken) {
        try {
          const payload = JSON.parse(atob(presonusIdToken.split(".")[1]));
          if (payload?.aud === environment.cognito.clientId) {
            if (!environment.production) {
              console.log("🔵 Detected PreSonus tokens in setTokensFromCookies");
            }
            return environment.cognito.clientId;
          }
        } catch (error) {
          console.error("Failed to decode PreSonus token:", error);
        }
      }
    }

    // Check Fender pool
    const fenderPrefix = `CognitoIdentityServiceProvider.${environment.fenderCognito.clientId}`;
    const fenderLastAuthUser = localStorage.getItem(`${fenderPrefix}.LastAuthUser`) || this._cookieService.get(`${fenderPrefix}.LastAuthUser`);

    if (fenderLastAuthUser) {
      const fenderIdToken = localStorage.getItem(`${fenderPrefix}.${fenderLastAuthUser}.idToken`) || this._cookieService.get(`${fenderPrefix}.${fenderLastAuthUser}.idToken`);
      if (fenderIdToken) {
        try {
          const payload = JSON.parse(atob(fenderIdToken.split(".")[1]));
          if (payload?.aud === environment.fenderCognito.clientId) {
            if (!environment.production) {
              console.log("🟠 Detected Fender tokens in setTokensFromCookies");
            }
            return environment.fenderCognito.clientId;
          }
        } catch (error) {
          console.error("Failed to decode Fender token:", error);
        }
      }
    }

    return null; // No valid tokens found
  }

  async goToFenderShop(shopRoute = "", newWindow = false) {
    if (this.orderService.fenderUserShopData) {
      let regionSubDomain = environment.stage == "prod" ? "www" : "us";
      if (this.orderService.fenderUserShopData.ssoStoreId == "EMEA") {
        regionSubDomain = "uk";
      } else if (this.orderService.fenderUserShopData.ssoStoreId != "US") {
        regionSubDomain = this.orderService.fenderUserShopData.ssoStoreId.toLowerCase();
      }
      let args = {
        type: "fender_shopify",
        firstName: this.userService.user.firstName,
        lastName: this.userService.user.lastName,
        photoURL: this.userService.user.photoURL,
        createdTime: this.userService.user.createdTime,
        username: this.userService.user.username,
        user_id: this.userService.user.id,
        user_agent: window.navigator.userAgent,
        storeID: this.orderService.fenderUserShopData.ssoStoreId,
        return_to: "https://" + regionSubDomain + "." + environment.fenderShopBaseUrl + (shopRoute ? "/" + shopRoute : ""),
      };
      const result: any = await firstValueFrom(this.userService.sso(args, this.helperService.accessToken));
      if (result && result.token) {
        let redirectURL = "";
        const url = require("url");
        const parsedReturnUrl = url.parse(args.return_to);
        const baseDomain = `${parsedReturnUrl.protocol}//${parsedReturnUrl.host}`;
        redirectURL = baseDomain + "/account/login/multipass/" + result.token;
        if (newWindow) {
          window.open(redirectURL, "_blank");
        } else {
          window.location.href = redirectURL;
        }
      }
    } else {
      if (newWindow) {
        window.open(environment.fenderDotComUrl + (shopRoute ? "/" + shopRoute : ""), "_blank");
      } else {
        window.location.href = environment.fenderDotComUrl + (shopRoute ? "/" + shopRoute : "");
      }
    }
  }

  showVideo(id) {
    let video = this.contentService.videosById[id];
    let args: any = {
      id: video.platform_id,
      title: video.title,
      type: video.platform,
      thumb: video.image,
      presonus_id: video.id,
    };
    this.eventBusService.emit(this.eventBusService.types.playVideo, args);
  }

  public initialAnimate: boolean = false;
  public beginInitialAnimate: boolean = false;
  showModal(content, args?, overVideo?, opaque?, alert?) {
    if (!args) args = {};
    if (!args.centered) args.centered = true;
    if (!args.size) args.size = "sm";
    if (!args.ariaLabelledBy) args.ariaLabelledBy = "modal-title";
    if (!args.backdrop) args.backdrop = "static";

    let body = document.getElementsByTagName("body")[0];
    if (overVideo) body.classList.add("modal-content-over-video");
    if (opaque) body.classList.add("opaque-modal-content");
    if (alert) body.classList.add("alert-modal-content");
    let ref = this._modalService.open(content, args);

    ref.closed.pipe(take(1)).subscribe((result) => {
      body.classList.remove("modal-content-over-video");
      body.classList.remove("opaque-modal-content");
    });
    ref.dismissed.pipe(take(1)).subscribe((result) => {
      body.classList.remove("modal-content-over-video");
      body.classList.remove("opaque-modal-content");
    });
    return ref;
  }

  alert(msg, closeText?) {
    let modalRef = this.showModal(GenericAlertComponent, { size: "sm" }, false, false, true);
    modalRef.componentInstance.html = msg;
    modalRef.componentInstance.closeText = closeText || this.translate.instant("general.ok");
  }

  confirm(msg, acceptText = "Confirm", rejectText = "Cancel") {
    return new Promise((resolve, reject) => {
      let resolved = false;
      let modalRef = this.showModal(GenericAlertComponent, { size: "sm" });
      modalRef.componentInstance.html = msg;
      modalRef.componentInstance.submitText = acceptText;
      modalRef.componentInstance.submitFn = () => {
        resolved = true;
        resolve(true);
      };
      modalRef.componentInstance.closeText = rejectText;
      modalRef.closed.subscribe((result) => {
        if (!resolved) {
          reject(false);
        }
      });
      modalRef.dismissed.subscribe((result) => {
        if (!resolved) {
          reject(false);
        }
      });
    });
  }

  closeModals() {
    this._modalService.dismissAll();
  }

  private _showNavOverlay: boolean = false;

  public set showNavOverlay(show) {
    this._showNavOverlay = show;
  }

  public get showNavOverlay() {
    return this._showNavOverlay;
  }

  get os() {
    if (this.win.navigator.platform.indexOf("Mac") > -1) {
      return "mac";
    } else if (this.win.navigator.platform.indexOf("Win") > -1) {
      return "win";
    } else if (this.win.navigator.platform.indexOf("Linux") > -1) {
      return "linux";
    }
  }

  public topNav: boolean = true;

  private _sortBy: string;
  get sortBy() {
    if (this._sortBy === undefined) {
      let stored = this._storage.getItem(StorageKeys.SORTBY);
      stored ? (this._sortBy = stored) : (this.sortBy = "date");
    }
    return this._sortBy;
  }

  set sortBy(preference: string) {
    this._storage.setItem(StorageKeys.SORTBY, preference);
    this._sortBy = preference;
  }

  private _fullscreenHeader;
  get fullscreenHeader() {
    return this._fullscreenHeader;
  }

  set fullscreenHeader(args) {
    if (args && args.image) args.image = encodeURI(args.image);
    this._fullscreenHeader = args;
  }

  private _fullscreenBG;
  get fullscreenBG() {
    return this._fullscreenBG;
  }

  set fullscreenBG(args) {
    this._fullscreenBG = args;
  }

  set title(title) {
    this._title.setTitle(title);
  }

  public preferredSortDirection: string = "desc";

  private _sortDirection: string;
  get sortDirection() {
    if (this._sortDirection === undefined) {
      let stored = this._storage.getItem(StorageKeys.SORTDIRECTION);
      this._sortDirection = stored ? stored : this.preferredSortDirection;
    }
    return this._sortDirection;
  }

  set sortDirection(preference: string) {
    this._storage.setItem(StorageKeys.SORTDIRECTION, preference);
    this._sortDirection = preference;
  }

  private _sortGroupByType: boolean;
  get sortGroupByType() {
    if (this._sortGroupByType === undefined) {
      let stored = this._storage.getItem(StorageKeys.SORTGROUPBYTYPE);
      if (stored === undefined) {
        this._sortGroupByType = true;
      } else {
        this._sortGroupByType = stored;
      }
    }
    return this._sortGroupByType;
  }

  set sortGroupByType(preference: boolean) {
    this._storage.setItem(StorageKeys.SORTGROUPBYTYPE, preference);
    this._sortGroupByType = preference;
  }

  private _prefersGrid: boolean;
  get prefersGrid() {
    if (this._prefersGrid === undefined) {
      const storedPref = this._storage.getItem(StorageKeys.PREFERSGRID);
      if (storedPref === false) {
        this._prefersGrid = false;
      } else {
        this._prefersGrid = true;
      }
    }
    return this._prefersGrid;
  }

  set prefersGrid(preference: boolean) {
    this._storage.setItem(StorageKeys.PREFERSGRID, preference);
    this._prefersGrid = preference;
  }

  public switchLayoutPreference() {
    const pref = this.prefersGrid;
    this.prefersGrid = !pref;
  }

  private _exchangePrefersGrid: boolean;
  get exchangePrefersGrid() {
    if (this._exchangePrefersGrid === undefined) {
      if (this._storage.getItem(StorageKeys.EXCHANGEPREFERSGRID)) {
        this._exchangePrefersGrid = true;
      } else {
        this._exchangePrefersGrid = false;
      }
    }
    return this._exchangePrefersGrid;
  }

  set exchangePrefersGrid(preference: boolean) {
    this._storage.setItem(StorageKeys.EXCHANGEPREFERSGRID, preference);
    this._exchangePrefersGrid = preference;
  }

  public switchExchangeLayoutPreference() {
    const pref = this.exchangePrefersGrid;
    this.exchangePrefersGrid = !pref;
  }

  urlify(text) {
    if (text) {
      var urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
      return text.replace(urlRegex, function (url) {
        return '<a href="' + url + '" target="_blank">' + url + "</a>";
      });
    } else {
      return text;
    }
  }

  refreshSubscriptionData(force?) {
    return this.userService.getSubscriptionDetails(force).subscribe();
  }

  setRefTagCookie(refTag, samesite: "Lax" | "None" | "Strict" = "Lax") {
    this._cookieService.set("reftag", refTag, {
      path: "/",
      domain: environment.cookieLocation,
      secure: true,
      sameSite: samesite,
    });
  }

  /**
   * Sync Cognito tokens from localStorage to cookies for cross-domain access
   * Cognito uses localStorage by default, but we need cookies for presonus.com, shop, etc.
   */
  syncCognitoTokensToCookies() {
    // Find all Cognito client IDs by scanning localStorage for LastAuthUser keys
    const cognitoPrefix = "CognitoIdentityServiceProvider.";
    const lastAuthUserSuffix = ".LastAuthUser";
    const clientIds = new Set<string>();

    // Iterate through localStorage to find all Cognito clientIds
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith(cognitoPrefix) && key.endsWith(lastAuthUserSuffix)) {
        // Extract clientId from key: CognitoIdentityServiceProvider.{clientId}.LastAuthUser
        const clientId = key.substring(cognitoPrefix.length, key.length - lastAuthUserSuffix.length);
        clientIds.add(clientId);
      }
    }

    // Sync tokens for each discovered clientId
    clientIds.forEach((clientId) => {
      const lastUserKey = `${cognitoPrefix}${clientId}.LastAuthUser`;
      const lastUser = localStorage.getItem(lastUserKey);

      if (lastUser) {
        // Copy LastAuthUser to cookie
        this._cookieService.set(lastUserKey, lastUser, {
          expires: 365,
          path: "/",
          domain: this.app == "fender" ? environment.fenderCookieLocation : environment.cookieLocation,
          secure: true,
          sameSite: "None",
        });

        // Copy all token keys to cookies for cross-domain access
        const tokenKeys = ["idToken", "accessToken", "refreshToken", "clockDrift", "deviceKey", "deviceGroupKey"];
        tokenKeys.forEach((tokenType) => {
          const key = `${cognitoPrefix}${clientId}.${lastUser}.${tokenType}`;
          const value = localStorage.getItem(key);
          if (value) {
            this._cookieService.set(key, value, {
              expires: 365,
              path: "/",
              domain: this.app == "fender" ? environment.fenderCookieLocation : environment.cookieLocation,
              secure: true,
              sameSite: "None",
            });
          }
        });
      }
    });
  }

  setXplatformCookies() {
    // Sync Cognito localStorage tokens to cookies for cross-domain access
    this.syncCognitoTokensToCookies();
  }

  deleteCookies() {
    // Clear all Cognito storage to ensure a clean state
    this.clearAllCognitoStorage();
  }

  /**
   * Clear all Cognito-related storage (localStorage, sessionStorage, cookies) for both PreSonus and Fender pools
   * This helps prevent "Unable to get user session" errors caused by stale/corrupted tokens
   * Clears ALL Cognito cookies across all domains to prevent orphaned sessions
   */
  clearAllCognitoStorage() {
    // Clear all localStorage keys that start with CognitoIdentityServiceProvider
    const localStorageKeys = Object.keys(localStorage);
    localStorageKeys.forEach((key) => {
      if (key.startsWith("CognitoIdentityServiceProvider")) {
        localStorage.removeItem(key);
      }
    });

    // Clear all sessionStorage keys that start with CognitoIdentityServiceProvider
    const sessionStorageKeys = Object.keys(sessionStorage);
    sessionStorageKeys.forEach((key) => {
      if (key.startsWith("CognitoIdentityServiceProvider")) {
        sessionStorage.removeItem(key);
      }
    });

    // Clear all Amplify-specific storage
    const amplifyKeys = ["amplify-signin-with-hostedUI", "amplify-redirected-from-hosted-ui"];
    amplifyKeys.forEach((key) => {
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
    });

    // Get all cookies and delete any that start with CognitoIdentityServiceProvider
    const allCookies = document.cookie.split(";");
    const cognitoCookieNames: string[] = [];

    allCookies.forEach((cookie) => {
      const cookieName = cookie.split("=")[0].trim();
      if (cookieName.startsWith("CognitoIdentityServiceProvider") || cookieName.startsWith("amplify-")) {
        cognitoCookieNames.push(cookieName);
      }
    });

    // Delete cookies from all possible domains
    const cookieDomains = [
      ".presonus.com",
      "presonus.com",
      ".fender.com",
      "fender.com",
      ".fendergarage.com",
      "fendergarage.com",
      environment.cookieLocation,
      environment.connectCookieLocation,
      environment.fenderCookieLocation,
      "localhost",
      ".localhost",
    ];

    cognitoCookieNames.forEach((cookieName) => {
      // Delete from each possible domain
      cookieDomains.forEach((domain) => {
        this._cookieService.delete(cookieName, "/", domain);
        // Also try with different paths
        this._cookieService.delete(cookieName, "", domain);
      });

      // Also try deleting without specifying domain (for current domain)
      this._cookieService.delete(cookieName, "/");
      this._cookieService.delete(cookieName);
    });

    if (!environment.production) {
      console.log("🧹 Cleared all Cognito storage:", {
        localStorageCleared: localStorageKeys.filter((k) => k.startsWith("CognitoIdentityServiceProvider")).length,
        sessionStorageCleared: sessionStorageKeys.filter((k) => k.startsWith("CognitoIdentityServiceProvider")).length,
        cookiesCleared: cognitoCookieNames.length,
      });
    }
  }

  alertError(error, alert500?) {
    if (error.status == 500 && !alert500) {
      this.alert("An unknown error occurred. We are looking into it!");
      this.errorService.reportError(error);
    } else {
      this.alert(this.helperService.retrieveErrorMessage(error));
    }
  }

  promptSimpleSignup(cmp) {
    return new Promise((resolve, reject) => {
      let modalRef = this.showModal(cmp, { size: "lg" });
      modalRef.result.then(
        (token) => {
          if (token) {
            resolve(token);
          } else {
            reject(new Error("User cancelled."));
          }
        },
        (error) => {
          reject(new Error("User cancelled."));
        }
      );
    });
  }

  public selectedTheme: string;
  public activeTheme: "dark" | "light";
  initTheme(preference?) {
    const handle = (value) => {
      let body = document.getElementsByTagName("body")[0];
      body.classList.remove("theme_atom1");
      body.classList.remove("theme_atom2");
      body.classList.remove("theme_s14");
      body.classList.remove("theme_s142");
      body.classList.remove("theme_blue");
      body.classList.remove("theme_green");
      body.classList.remove("theme_red");
      body.classList.remove("theme_dark");
      body.classList.remove("theme_sphere");
      body.classList.remove("theme_sphere1");
      body.classList.remove("theme_plaindark");
      body.classList.remove("theme_plainlight");
      body.classList.add(this.app);
      if (this.app == "fender") {
        this.appName = "My Fender";
      }
      body.classList.add("fender-ui-layout");
      if (value) {
        if (value == "auto") {
          body.classList.add(window.matchMedia("(prefers-color-scheme: dark)").matches ? "theme_plaindark" : "theme_plainlight");
          // also add data-color-mode=light or dark to the html tag
          document.documentElement.setAttribute("data-color-mode", window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light");
          if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
            this.activeTheme = "dark";
            this.userService.activeTheme = "dark";
            this.presonusAdminLogo = "./assets/images/paeadmin+white.png";
            this.s1pro7Logo = "./assets/images/s17-images/s1pro7-white.png";
            this.s1proPlusLogo = "./assets/images/s17-images/s1plus-logo-white.png";
            this.presonusLogo = "./assets/images/pae+white.png";
          } else {
            this.activeTheme = "light";
            this.userService.activeTheme = "light";
            this.presonusLogo = "./assets/images/pae+black.png";
            this.presonusAdminLogo = "./assets/images/paeadmin+black.png";
            this.s1pro7Logo = "./assets/images/s17-images/s1pro7-black.png";
            this.s1proPlusLogo = "./assets/images/s17-images/s1plus-logo-black.png";
          }
          this.headerLogo = "./assets/images/fender-logo-red.png";
        } else {
          if (value != "plainlight") value = "plaindark"; // this effectively removes all themes except plaindark and plainlight
          body.classList.add("theme_" + value);
          document.documentElement.setAttribute("data-color-mode", value == "plainlight" ? "light" : "dark");
          if (value == "plainlight") {
            this.activeTheme = "light";
            this.userService.activeTheme = "light";
            this.presonusLogo = "./assets/images/pae+black.png";
            this.presonusAdminLogo = "./assets/images/paeadmin+black.png";
            this.s1pro7Logo = "./assets/images/s17-images/s1pro7-black.png";
            this.s1proPlusLogo = "./assets/images/s17-images/s1plus-logo-black.png";
          } else {
            this.activeTheme = "dark";
            this.userService.activeTheme = "dark";
            this.presonusLogo = "./assets/images/pae+white.png";
            this.presonusAdminLogo = "./assets/images/paeadmin+white.png";
            this.s1pro7Logo = "./assets/images/s17-images/s1pro7-white.png";
            this.s1proPlusLogo = "./assets/images/s17-images/s1plus-logo-white.png";
          }
          this.headerLogo = "./assets/images/fender-logo-red.png";
        }
        this.selectedTheme = value;
      }
    };

    this.userService.themeImg$.subscribe((value) => {
      handle(value);
    });

    if (preference) {
      this.userService.themeImg = preference;
      handle(preference);
    }

    window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", (e) => {
      this.systemThemeChange$.next(window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light");
      this.systemTheme = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
      if (this.userService.themeImg == "auto") {
        this.userService.themeImg$.next("auto");
        let body = document.getElementsByTagName("body")[0];
        body.classList.remove("theme_atom1");
        body.classList.remove("theme_atom2");
        body.classList.remove("theme_s14");
        body.classList.remove("theme_s142");
        body.classList.remove("theme_blue");
        body.classList.remove("theme_green");
        body.classList.remove("theme_red");
        body.classList.remove("theme_dark");
        body.classList.remove("theme_sphere");
        body.classList.remove("theme_sphere1");
        body.classList.remove("theme_plaindark");
        body.classList.remove("theme_plainlight");
        body.classList.add(window.matchMedia("(prefers-color-scheme: dark)").matches ? "theme_plaindark" : "theme_plainlight");
        document.documentElement.setAttribute("data-color-mode", window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light");
      }
      if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
        this.presonusAdminLogo = "./assets/images/paeadmin+white.png";
        this.s1pro7Logo = "./assets/images/s17-images/s1pro7-white.png";
        this.s1proPlusLogo = "./assets/images/s17-images/s1plus-logo-white.png";
        this.presonusLogo = "./assets/images/pae+white.png";
      } else {
        this.presonusLogo = "./assets/images/pae+black.png";
        this.presonusAdminLogo = "./assets/images/paeadmin+black.png";
        this.s1pro7Logo = "./assets/images/s17-images/s1pro7-black.png";
        this.s1proPlusLogo = "./assets/images/s17-images/s1plus-logo-black.png";
      }
      this.headerLogo = "./assets/images/fender-logo-red.png";
      if (this.userService.themeImg == "auto") this.userService.themeImg$.next("auto");
    });
  }

  showThemeChooser(cmp) {
    return this.showModal(cmp, { size: "lg" });
  }

  showLanguageChooser() {
    this.showLangSwitcher$.next(true);
  }

  getElementOffsetFromBody(el) {
    let top = 0;
    while (el && el !== document.body) {
      top += el.offsetTop;
      el = el.offsetParent;
    }
    return top;
  }

  public logout(skipApiLogout?) {
    this.clearAllCognitoStorage();
    return this.userService.logout(skipApiLogout);
  }

  public redirecting: boolean = false;
  redirectToConnect(includeReturnTo?, includeLogout?, sso?, defaultSection = "home") {
    this.logout(true).subscribe(() => {
      let baseUrl = environment.fenderUrl;
      if (sso == "admin") baseUrl = environment.connectUrl;
      defaultSection = "login";
      if (this.app == "sphere") {
        defaultSection = "login";
        baseUrl = "";
        // make sure were not already on the login page
        if (location.pathname.indexOf("login") > -1) {
          return;
        }
      }
      if (!this.redirecting) {
        this.redirecting = true;
        if (includeReturnTo && location.pathname && location.pathname.indexOf("logout") == -1) {
          let href = baseUrl + defaultSection + "?returnto=" + location.pathname + (location.search && location.search.indexOf("logout") == -1 ? encodeURIComponent(location.search) : "");
          if (sso) href += "&sso=" + sso;
          window.location.href = href;
          return false;
        } else if (includeLogout) {
          window.location.href = baseUrl + defaultSection + "?logout=true" + (sso ? "&sso=" + sso : "");
        }
      }
    });
  }

  private _handleFenderShopDetails() {
    this.orderService.getFenderShopifyAccountDetails(this.userService.user.email, false, "FENDER_US").subscribe();
  }

  private _handleMetroData() {
    this.fbService
      .handleFirestorePromise(() => this.db.collection("linked_user_invitations").doc(this.userService.user.email).ref.get())
      .then((result) => {
        if (result.exists) {
          let item = <any>result.data();
          this.db
            .collection("user_profiles")
            .doc(this.userService.user.id)
            .collection("linked_users")
            .doc(item.initiatedBy)
            .set({
              email: item.email,
              name: item.name,
              photo: item.photo,
              linkedUsersTag: this.fbService.increment(1),
              status: "pending",
              userId: item.initiatedBy,
              initiatedBy: item.initiatedBy,
            })
            .then(() => {
              this.db
                .collection("user_profiles")
                .doc(item.initiatedBy)
                .collection("linked_users")
                .doc(this.userService.user.id)
                .set({
                  email: this.userService.user.email,
                  name: this.userService.user.firstName ? this.userService.user.firstName + " " + this.userService.user.lastName : this.userService.user.email,
                  photo: this.userService.user.photoURL,
                  status: "pending",
                  linkedUsersTag: this.fbService.increment(1),
                  userId: this.userService.user.id,
                  initiatedBy: item.initiatedBy,
                })
                .then(() => {
                  this.fbService.doc(`linked_user_invitations/${this.userService.user.email}`).delete();
                });
            });
        }
      });
  }

  private _handleSphereAnnouncements() {
    this.fbService
      .handleFirestoreObservable(() => {
        return this.db.collection("sphere_announcements").get().pipe(take(1));
      })
      .subscribe({
        next: (result) => {
          let seenAnnouncements: any = {};
          if (this.userService.userMetadata && this.userService.userMetadata.sphere_announcements) seenAnnouncements = this.userService.userMetadata.sphere_announcements;
          if (!seenAnnouncements.my_fender_welcome) {
            this.showMyFenderWelcome();
            return;
          }
          let updatesToShow = [];
          result.docs.forEach((doc: any) => {
            let announcement = doc.data();
            if (environment.production && announcement.dev) {
              // dont do anything with dev ones if were in production.
            } else if (
              !seenAnnouncements[announcement.string_id] &&
              announcement.date.toDate() <= new Date() &&
              announcement.date.toDate() >= new Date(this.userService.user.createdTime) &&
              (!announcement.audience || (announcement.audience.length && announcement.audience.includes("web"))) &&
              (this.userService.user.active_subscription || !announcement.members_only)
            ) {
              if (!announcement.products && !announcement.group_ids) {
                // No restrictions, show to everyone
                updatesToShow.push(announcement);
              } else if (announcement.products && announcement.group_ids) {
                // Both restrictions: user needs to have the product AND be in the group
                let hasAProduct = false;
                let isInGroup = false;
                announcement.products.forEach((stringId) => {
                  if (this.productService.productsByStringIDs[stringId]) hasAProduct = true;
                });
                announcement.group_ids.forEach((groupId) => {
                  if (this.userService.user.groups.some((group) => group.name === groupId)) isInGroup = true;
                });
                if (hasAProduct && isInGroup) updatesToShow.push(announcement);
              } else if (announcement.products && !announcement.group_ids) {
                // Only product restriction: user needs to have the product
                let hasAProduct = false;
                announcement.products.forEach((stringId) => {
                  if (this.productService.productsByStringIDs[stringId]) hasAProduct = true;
                });
                if (hasAProduct) updatesToShow.push(announcement);
              } else if (!announcement.products && announcement.group_ids) {
                // Only group restriction: user needs to be in the group
                let isInGroup = false;
                announcement.group_ids.forEach((groupId) => {
                  if (this.userService.user.groups.some((group) => group.name === groupId)) isInGroup = true;
                });
                if (isInGroup) updatesToShow.push(announcement);
              }
            }
          });
          if (updatesToShow.length) {
            let modal = this.showModal(FeatureUpdatesComponent, { size: "lg", ariaLabelledBy: "modal-title" });
            modal.componentInstance.features = updatesToShow;
          }
        },
        error: (error) => {
          // console.log("err in sphere announcements", error);
        },
      });
  }

  public showMyFenderWelcome() {
    let modal = this.showModal(MyFenderWelcomeComponent, { size: "lg", ariaLabelledBy: "modal-title" });
  }

  applicationData$: BehaviorSubject<any> = new BehaviorSubject(null);
  private _handleApplicationData() {
    this.productService.initProducts(true);
    this.betaService.getBetas().subscribe();
    this.userService.getSubscriptionDetails().subscribe((result) => {
      this.userService.getApplicationData().subscribe(async (result: any) => {
        this.communityService.updateConnections(result.connections || []);
        this.contentService.handleEducationData(result.learnData, this.userService.user.is_admin);
        this.applicationData$.next(result);
        // we may want to use this one day if fender ever decides to verify emails.
        // if (this.helperService.token.length > 50 && !environment.features.useFenderCognito) {
        //   // dont do this for legacy tokens.
        //   if (!this.userService.user.active) {
        //     let attributes = await fetchUserAttributes();
        //     attributes = this.processCognitoAttributes(attributes);
        //     if (!attributes.email_verified) {
        //       if (!environment.production && attributes.email?.indexOf("mailinator") > -1) {
        //         // do not force mailinator to verify email in dev or qa
        //       } else {
        //         this._modalService.dismissAll();
        //         if (this.router.url != "/account/general") {
        //           this.showModal(VerifyEmailComponent, { size: "sm", keyboard: false });
        //         }
        //       }
        //     }
        //   }
        // }
      });
    });
  }

  public processCognitoAttributes(attributes) {
    for (var i in attributes) {
      if (attributes[i] == "true") {
        attributes[i] = true;
      } else if (attributes[i] == "false") {
        attributes[i] = false;
      }
    }
    return attributes;
  }

  private _handleUserMetadata() {
    this.fbService
      .handleFirestoreObservable(() => {
        return this.db
          .doc("user_metadata/" + this.userService.user.id)
          .get()
          .pipe(take(1));
      })
      .subscribe({
        next: (metadata) => {
          this.userService.userMetadata = metadata && metadata.data() ? metadata.data() : {};
          let storedCommunityProfile = this._storage.getItem(StorageKeys.COMMUNITY_PROFILE);
          if (storedCommunityProfile) {
            this.communityService.hasSetupCommunity = storedCommunityProfile.hasSetupCommunity ? true : false;
            this.communityService.firebaseProfile$.next(storedCommunityProfile);
          } else {
            this.communityService.getFirebaseProfile().then((result) => {
              if (result) {
                let userData: any = result;
                this.communityService.hasSetupCommunity = userData.hasSetupCommunity ? true : false;
                if (!userData.photo) {
                  this.fbService.doc("user_profiles/" + this.userService.user.id).set(
                    {
                      photo: this.userService.user.photoURL,
                      email: this.userService.user.email,
                    },
                    { merge: true }
                  );
                }
              } else {
                let fbUserProfileArgs: any = {
                  id: this.userService.user.id,
                  email: this.userService.user.email,
                  photo: this.userService.user.photoURL,
                };
                if (this.userService.user.firstName) {
                  fbUserProfileArgs.name = this.userService.user.firstName + " " + this.userService.user.lastName;
                }
                this.fbService.doc("user_profiles/" + this.userService.user.id).set(fbUserProfileArgs);
                this.communityService.hasSetupCommunity = false;
              }
            });
          }
          this.productService.products$
            .pipe(
              filter((items) => !!items),
              take(1)
            )
            .subscribe((products) => {
              this._handleSphereAnnouncements();
            });
        },
        error: (error) => {
          // console.log(error);
        },
      });
  }

  public hasInittedApp: boolean = false;
  initApp() {
    if (!this.hasInittedApp) {
      if (this.userService.loggingOut || !this.userService.user || !this.helperService.token) {
        return false;
      }
      this._handleMetroData();
      this._handleApplicationData();
      this._handleUserMetadata();
      this._handleFenderShopDetails();
      this.communityService.listenNotificationUpdates();
      this.communityService.getTopics();
      this.userService.themeImg = this.userService.user.theme ? this.userService.user.theme : "auto";
      this.communityService.watchMissedMessageCounts();
      this.messagingService.requestPermission().then(() => {
        this.messagingService.receiveMessage();
      });
      if (this.userService.user.active_subscription) {
        this.refreshSubscriptionData(true);
      }
      this.productService.products$
        .pipe(
          filter((items) => !!items),
          take(1)
        )
        .subscribe((products) => {
          if (!products.length) {
            if (moment(this.userService.user.createdTime).format("YYYY-MM-DD") == moment().format("YYYY-MM-DD")) {
              // if they just signed up, try again as the shop webhook may not have fired yet.
              this.win.setTimeout(() => {
                this.productService.getProducts(true).subscribe();
              }, 3000);
            }
          }
        });
      this.hasInittedApp = true;
    }
  }

  public decodeHtmlCharacters(string) {
    return new DOMParser().parseFromString(string, "text/html").body.textContent;
  }

  public goToCheckout(url, productId?, total?) {
    if (productId) {
      this.avoService.avoInitted$.pipe(filter((result) => !!result)).subscribe((result) => {
        this.avoService.trackEvent().checkoutStarted({
          siteId: this.userService.user?.active_subscription ? "studio_one_plus" : "mypresonus",
          locale: (this.userService.user.language_code || "en") + "-" + (this.userService.user?.country || "US"),
          products: [
            {
              price: total,
              sku: productId,
              productId: productId,
              quantity: 1,
              name: "Studio One Plus",
            },
          ],
          countryCode: this.userService.user.country,
          total: total,
          price: total,
          quantity: 1,
        });
      });
    }
    this.win.setTimeout(() => {
      window.location.assign(url);
    }, 1000);
  }

  private checkGhostNavRoute() {
    if (this.app != "fender") return;
    const currentPath = this.router.url.split("?")[0]; // Remove query params
    let body = document.getElementsByTagName("body")[0];

    // Check if current route matches any ghost nav route
    for (const route in this.ghostNavRoutes) {
      if (currentPath === `/${route}` || currentPath === route) {
        this.currentGhostNavRoute = route;
        this.showGhostNav = true;
        body.classList.add("ghost-nav-route");
        return;
      }
    }

    // Not a ghost nav route
    this.currentGhostNavRoute = null;
    this.showGhostNav = false;
    body.classList.remove("ghost-nav-route");
  }

  private handleGhostNavScroll(scrollTop: number) {
    if (this.app != "fender") return;
    if (this.currentGhostNavRoute && this.ghostNavRoutes[this.currentGhostNavRoute]) {
      const unsetValue = this.ghostNavRoutes[this.currentGhostNavRoute].unset;

      if (scrollTop >= unsetValue) {
        this.showGhostNav = false;
      } else {
        this.showGhostNav = true;
      }
    }
  }

  private setRouteClass() {
    const currentPath = this.router.url.split("?")[0]; // Remove query params
    let body = document.getElementsByTagName("body")[0];

    // Remove previous route class if it exists
    if (this.currentRouteClass) {
      body.classList.remove(this.currentRouteClass);
    }

    // Extract the first segment of the path (e.g., /workspaces/1234/detail -> workspaces)
    const segments = currentPath.split("/").filter((s) => s.length > 0);
    if (segments.length > 0) {
      const routeClass = segments[0];
      this.currentRouteClass = routeClass;
      body.classList.add(routeClass);
    } else {
      // Handle root path
      this.currentRouteClass = "home";
      body.classList.add("home");
    }
  }

  /**
   * Generate random gradient colors that respect the current theme
   * @returns Object with color1 (start) and color2 (end) hex values
   */
  public generateRandomGradient(): { color1: string; color2: string } {
    const isDark = this.activeTheme === "dark";

    // Helper to generate a random hex color within a range
    const randomColorInRange = (min: number, max: number): string => {
      const r = Math.floor(Math.random() * (max - min) + min);
      const g = Math.floor(Math.random() * (max - min) + min);
      const b = Math.floor(Math.random() * (max - min) + min);
      return `#${r.toString(16).padStart(2, "0")}${g.toString(16).padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;
    };

    if (isDark) {
      // Dark theme: colors in range #0a0a0a to #3a3a3a (10-58 in decimal)
      return {
        color1: randomColorInRange(10, 58),
        color2: randomColorInRange(10, 58),
      };
    } else {
      // Light theme: colors in range #c8c8c8 to #ffffff (200-255 in decimal)
      return {
        color1: randomColorInRange(200, 255),
        color2: randomColorInRange(200, 255),
      };
    }
  }
}
